import { useNavigate } from "react-router-dom";
import { ChevronLeft } from "lucide-react";

/** Back button + title for pushed (non-tab) pages. */
export function BackHeader({ title, right, fallback = "/profile", testId = "page-header" }) {
  const navigate = useNavigate();
  const back = () => (window.history.state?.idx > 0 ? navigate(-1) : navigate(fallback, { replace: true }));
  return (
    <div className="mb-6 flex items-center gap-3" data-testid={testId}>
      <button data-testid="stack-back-button" aria-label="Go back" onClick={back} className="-ml-2 flex h-11 w-11 shrink-0 items-center justify-center rounded-full transition-colors hover:bg-[#F4EBE6]">
        <ChevronLeft className="h-6 w-6" />
      </button>
      <h1 className="min-w-0 flex-1 truncate text-[30px] leading-tight md:text-[36px]">{title}</h1>
      {right}
    </div>
  );
}
